module.exports = __webpack_public_path__ + "img/official-site-qrcode.8156a855.png";